<template>
  <div class="box">
    <figure class="avatar">
      <img class="imagen-docente" src="@/assets/docente.svg" />
    </figure>
    <form @submit.prevent="consultar" class="has-text-left">
      <div class="field">
        <label class="label">Nº documento de identidad</label>
        <div class="control has-icons-left">
          <input
            class="input has-text-right"
            type="number"
            placeholder="Documento de identidad"
            autofocus="true"
            v-model="cedula"
            :disabled="disabled"
            required="required"
          />
          <span class="icon is-left">
            <i class="fas fa-id-card-alt"></i>
          </span>
        </div>
      </div>
      <div class="field is-grouped is-grouped-right">
        <p class="control">
          <button
            class="button is-block is-info"
            :class="{ 'is-loading': consultando, 'is-success': valido }"
            :disabled="disabled || cedula == ''"
          >
            <i v-if="valido" class="fas fa-check"></i>
            <span v-else>Consultar</span>
          </button>
        </p>
      </div>
      <p v-if="error_msg" class="help is-danger">{{ error_msg }}</p>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { consultarCedula } from "@/api.js";
export default {
  data: function () {
    return {
      cedula: "",
      consultando: false,
      error_msg: "",
    };
  },
  computed: {
    disabled() {
      return this.consultando;
    },
    valido() {
      return this.$store.getters.valida;
    },
  },
  mounted() {
    console.log(consultarCedula());
  },
  methods: {
    consultar: function () {
      this.consultando = true;
      axios
        .post(consultarCedula(), {
          documento: this.cedula,
        })
        .then((response) => {
          console.log(response);
          let cedula;
          let debeActualizar;
          switch (response.data.codigo_respuesta) {
            case 2:
              cedula = this.cedula;
              debeActualizar = true;
              this.$store.commit("setCedula", response.data.documento);
              setTimeout(() => {
                this.$router.push({ name: "Inscripcion" });
              }, 600);
              break;
            case 3:
              alert("El docente ya ha sido formado");
              break;
            case 4:
              this.consultando = false;
              cedula = this.cedula;
              debeActualizar = false;
              this.$store.dispatch("setValidar", { cedula, debeActualizar });
              this.$store.commit(
                "setDatosAct",
                response.data.data_participante
              );
              this.$store.commit(
                "setPaticipanteAct",
                response.data.tipo_participante
              );
              setTimeout(() => {
                this.$router.push({ name: "Actualización" });
              }, 600);

              break;
            default:
              break;
          }
          // this.cedula = "";
        })
        .catch((error) => {
          console.log("Error");
          console.log(error);
          if (error.response.status == 406 || error.response.status == 400) {
            switch (error.response.data.codigo_respuesta) {
              case 0:
                this.error_msg =
                  "El documento de identidad y/o fecha de nacimiento no tienen un formato valido";
                alert(
                  "El documento de identidad y/o fecha de nacimiento no tienen un formato valido"
                );
                break;
              case 1:
                this.error_msg = "No existe la estrategia de inscripción";
                // alert('No existe la estrategia de inscripción');
                break;
              case 5:
                alert("Usted ya se encuentra en proceso de aprobación");
                this.error_msg =
                  "Usted ya se encuentra en proceso de aprobación";
                break;
            }
          }
        })
        .then(() => {
          this.consultando = false;
        });
    },
  },

  watch: {},
};
</script>
<style lang="scss" scoped>
.imagen-docente {
  max-width: 128px;
  max-height: 128px;
}
</style>
